// Rechenregeln der Wallpaper-Vorschau, wie im Renderer (mode.rs, scene.rs). Ohne DOM, damit testbar.
import type { WallpaperSettings } from './api';

/** Seitenverhältnis der Vorschau (.desk) */
export const ASPECT = 1.6;

export const boardsOf = (s: WallpaperSettings): number =>
  s.mode === 'gallery' ? 3 : s.mode === 'simul' ? Math.min(64, Math.max(2, s.boards)) : 1;

/** Faktor auf das Zugtempo je Brett, wie Mode::tempo im Renderer */
export const tempo = (s: WallpaperSettings, n: number): number => (s.mode === 'simul' ? Math.max(2, n / 4) : 1);

/** Raster wie simul() in scene.rs, alles in cqh: Brett höchstens `want`, kleine Bretter rücken zusammen. */
export function simulGrid(n: number, want: number, aspect = ASPECT): { cols: number; bs: number; cw: number; ch: number } {
  const [aw, ah] = [aspect * 94, 92];
  const capOf = (bs: number) => Math.max(bs * 0.05, 0.8) * 2.2;
  const fit = (c: number, cap: number) => Math.min((aw / c) * 0.84, (ah / Math.ceil(n / c) - cap) * 0.9);
  const best = (cap: number) => Math.max(...Array.from({ length: n }, (_, i) => fit(i + 1, cap)));
  const cap = capOf(Math.min(want, best(capOf(Math.min(want, best(0))))));
  const bs = Math.min(want, best(cap));
  const pitch = (c: number) => [Math.min(bs * 1.3, aw / c), Math.min((bs + cap) * 1.2, ah / Math.ceil(n / c))];
  const score = (c: number) => {
    const [px, py] = pitch(c), r = Math.ceil(n / c);
    return Math.abs((c * px) / (r * py) - aspect) + (3 * (c * r - n)) / n;
  };
  let cols = 0;
  for (let c = 1; c <= n; c++) if (fit(c, cap) >= bs - 1e-9 && (!cols || score(c) < score(cols))) cols = c;
  const [cw, ch] = pitch(cols);
  return { cols, bs, cw, ch };
}

/** Halbzug von Brett `k`: es zieht nur bei jedem n-ten Takt, versetzt zu den anderen. */
export function plyOf(k: number, n: number, ticks: number, len: number): number {
  return len ? (k * 7 + Math.max(0, Math.floor((ticks + n - 1 - k) / n))) % len : 0;
}
